<template>
  <div class="marquee">
    <div class="inner-card">
      <slot></slot>
    </div>
    <!-- <div>
      <span>You spin me right round, baby. Like a record, baby.</span>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // speed: "fast",
      // direction: "left",
    }
  },
  computed: {
    isDesktop() {
      return this.$store.state.isDesktop;
    }
  },
  mounted() {
    // this.addAnimation();
  },
  methods: {
    addAnimation() {
        const scroller = this.$el;
        const scrollerInner = scroller.querySelector(".scroller__inner");
        const scrollerContent = Array.from(scrollerInner.children);
        const itemCount = scrollerContent.length;
        // const itemsNeeded = 10 - itemCount;

        // if (itemsNeeded > 0) {
        //   for (let i = 0; i < itemsNeeded; i++) {
        //     scrollerContent.forEach((item) => {
        //       const duplicatedItem = item.cloneNode(true);
        //       duplicatedItem.setAttribute("aria-hidden", true);
        //       scrollerInner.appendChild(duplicatedItem);
        //     });
        //   }
        // }

        scroller.setAttribute("data-animated", true);
    }
  }
};
</script>

<style>


.marquee {
  /* height: 25px;
  width: 420px; */
  height: 100%;
  width: 100%;

  overflow: hidden;
  position: relative;
}

.marquee .inner-card {
  /* display: block; */
  /* width: 200%;
  height: 30px; */
  display: flex;
  /* flex-wrap: wrap; */
  gap: 1rem;
  width: auto;

  position: absolute;
  overflow: hidden;

  animation: marquee 45s linear infinite;
}
.marquee .inner-card:hover {
  animation-play-state: paused;
}
/* .marquee span {
  float: left;
  width: 50%;
} */

@keyframes marquee {
  0% { left: 50%; }
  100% { left: -300%; }
}
</style>
